// var windowElement = window,
//     footerElement = document.querySelector('footer'),
//     newsElement = document.querySelector('.videoSection');

// windowElement.addEventListener('scroll', function() {
//   var scrollTop = windowElement.scrollY;
//   var documentHeight = document.documentElement.scrollHeight;
//   var windowHeight = windowElement.innerHeight;
//   var newsHeight = newsElement.offsetHeight;
//   var threshold = documentHeight - windowHeight - footerElement.offsetHeight;

//    if (scrollTop > threshold) {
//     var translateYValue =  threshold - scrollTop   + 'px';
//     newsElement.style.transform = 'translateY(' + translateYValue + ')';
//   } else {
//     newsElement.style.transition = 'none';
//     newsElement.style.transform = 'none';
//   }
// });

function onboarding() {
  var emailValue = document.getElementById("on_email").value;
  var nameValue = document.getElementById("on_name").value;
  var contentValue = document.getElementById("on_content").value;

  var emailValidationMsg = document.getElementById("emailValidationMsg2");
  var nameMsg = document.getElementById("nameMsg");
  var contentMsg = document.getElementById("contentMsg");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // 이름 값이 비어 있는지 확인
  if (nameValue === "") {
    nameMsg.textContent = "Please type your name";
  } else {
    nameMsg.textContent = ""; // 에러 메시지를 지웁니다.
  }

  // 내용 값이 비어 있는지 및 최소 길이를 확인
  if (contentValue === "") {
    contentMsg.textContent = "Please enter the content";
  } else if (contentValue.length < 5) {
    // 최소 길이 조건 추가 (예시)
    contentMsg.textContent = "Content should be at least 5 characters long";
  } else {
    contentMsg.textContent = ""; // 에러 메시지를 지웁니다.
  }

  // 이메일 값이 비어 있는지 및 형식이 올바른지 확인
  if (emailValue === "") {
    emailValidationMsg.textContent =
      "The required value is missing, please type your email.";
  } else if (!emailRegex.test(emailValue)) {
    emailValidationMsg.textContent = "Invalid email format";
  } else {
    // 모든 조건이 충족되었을 때만 handleSubmit2 실행
    if (nameValue !== "" && contentValue !== "" && contentValue.length >= 5) {
      try {
        handleSubmit2(emailValue, nameValue, contentValue);
      } catch (error) {
        emailValidationMsg.textContent =
          "An error occurred. Please try again later.";
      }
    }
  }
}

const handleSubmit2 = async (email, name, content) => {
  try {
    const loadingDiv = document.querySelector(".loading");
    loadingDiv.classList.add("active");

    const formData = new URLSearchParams();
    formData.append("email", email);
    formData.append("name", name);
    formData.append("content", content);

    const response = await fetch("https://nftofotd.mycafe24.com/shopify/onboading", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    });

    loadingDiv.classList.remove("active");
    if (response.ok) {
      document.getElementById("onboarding").innerHTML =
        "<div class='resultMsg'><p class='success'>Your request has been received.</p><p class='success'>A reply will follow shortly.</p></div>";
    }
  } catch (error) {
    // Handle error appropriately
    emailValidationMsg.textContent =
      "An error occurred. Please try again later.";
  }
};

document.addEventListener("DOMContentLoaded", function () {
  // .btnOnb 요소를 찾습니다.
  var btnOnb = document.querySelector(".btnOnb");
  var close = document.querySelector(".close");

  // .btnOnb 요소를 클릭할 때마다 toggleActive 함수를 호출합니다.
  btnOnb.addEventListener("click", toggleActive);
  close.addEventListener("click", toggleActive);

  function toggleActive() {
    // .obForm 요소를 찾습니다.
    var obForm = document.querySelector(".obWrap");

    // .obForm 요소에 active 클래스가 있는지 확인합니다.
    var isActive = obForm.classList.contains("active");

    // active 클래스를 추가하거나 제거합니다.
    if (isActive) {
      obForm.classList.remove("active");
    } else {
      obForm.classList.add("active");
    }
  }
});

const text = `Welcome to OFOTD, the forefront of a new fashion era, where innovation meets sustainability. We’re creating a future where every creator can bring their product vision to life, supported by a community that shares that vision. Our mission is bold: to redefine brand creation with an unwavering commitment to eco-conscious practices, ensuring a greener, more sustainable fashion world. <span>Creator-led</span> At OFOTD, creators are the heart of our process. We’re dedicated to realizing their unique visions, transforming the fashion landscape with each innovative piece. <span>Sustainability</span> Our path to sustainable fashion is paved with selective partnerships, emphasizing eco-friendly materials and responsible production to minimize environmental impact. <span>Community</span> <span>Engagement</span> We prioritize community feedback, ensuring our products not only launch but are deeply desired by those who matter most. <span>Ready to redefine fashion with us? Connect with our team to start your journey.</span> `;
const duration = 7000; // 5초
const charPerSecond = text.length / (duration / 1000);
let index = 0;

function type() {
  const typingTextElement = document.getElementById("typing-text");
  typingTextElement.innerHTML = text.slice(0, Math.ceil(index));

  // Toggle visibility to create a blinking effect
  //typingTextElement.classList.toggle('blink');

  // Check if there are any HTML tags within the sliced portion
  const slicedText = text.slice(0, Math.ceil(index));
  const tags = slicedText.match(/<[^>]*>/g) || [];
  const tagsLength = tags.reduce((total, tag) => total + tag.length, 0);

  // Adjust index based on the length of HTML tags
  index += 1;

  if (index <= text.length + tagsLength) {
    setTimeout(type, 1000 / charPerSecond); // Adjust typing speed
  }
}

type();

setTimeout(function () {
  document.querySelector(".formArea").classList.add("active");
}, 7000);

// $(function(){
//   var objs = $('.obj');
//   var windowHeight = $(window).height();

//   $(window).on('scroll', function() {
//     var scrollPosition = $(this).scrollTop();
//     var currentPage = Math.floor(scrollPosition / windowHeight);
//     var lastIndex = objs.length - 1;

//     objs.each(function(index) {
//       if (index === currentPage || (currentPage === lastIndex && index === currentPage - 1)) {
//         $(this).addClass('active');
//       } else {
//         $(this).removeClass('active');
//       }
//     });

//     var ob_leftScroll = $(".ob_section").offset().top;
//     var winPosition = $(this).scrollTop();
//     var footerOffset = $(".shopify-section-group-footer-group").offset().top - windowHeight;

//     if (ob_leftScroll <= winPosition && winPosition <= footerOffset) {
//       var transfromY = winPosition - ob_leftScroll + "px";
//       $(".ob_left, .formArea").css("transform", "translateY("+ transfromY +")");
//     }
//   });

//   // Trigger scroll event to initially check element visibility
//   $(window).trigger('scroll');
// });

history.scrollRestoration = "manual";
// var swiper = new Swiper(".onboarding", {
//   direction: "vertical",
//   speed: 600,
//   parallax: true,
//   slidesPerView: 1,
//   mousewheel: true,
//   on: {
//     reachEnd: function () {
//       //swiper.mousewheel.disable();
//     }
//   }
// });

// window.addEventListener('wheel', function (event) {
//   if (event.deltaY < 0) {
//     swiper.mousewheel.enable();
//   } else if (event.deltaY > 0) {
//   }
// });
